// extracted by mini-css-extract-plugin
export var measureBox = "_bu-0";